const fieldValidation = {
  required: '{{fieldName}} 是必須的',
  pattern: '{{fieldName}} 無效',
  min: '{{fieldName}} 不得小於 {{value}}',
  max: '{{fieldName}} 不得大於 {{value}}',
};

export default fieldValidation;
